import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import { Navigation, Pagination, Autoplay } from "swiper/modules";
import react from '../../assets/react.png'
import html from '../../assets/html.png'
import css from '../../assets/css.png'
import js from '../../assets/js.png'
import bootstrap from '../../assets/bootstrap.png'
import tailwindcss from '../../assets/tailwindcss.png'
import figma from '../../assets/figma.png'
import xd from '../../assets/adobexd.png'

const images = [html,css,js,react,tailwindcss,bootstrap,figma,xd,html,css,js,react,tailwindcss,bootstrap,figma,xd];

const Slider = () => {
  return (
    <div className="w-full max-w-[1400px] gradul p-4   md:mx-auto overflow-hidden rounded-lg shadow-xl shadow-secondary/20">
      <Swiper
        modules={[Navigation, Pagination, Autoplay]}
        spaceBetween={20}
        // slidesPerView={4}
        breakpoints={{
            320: { slidesPerView: 4, spaceBetween: 10 }, // For small screens
            640: { slidesPerView: 4, spaceBetween: 10 }, // For tablets
            768: { slidesPerView: 5, spaceBetween: 20 }, // Medium devices
            1024: { slidesPerView: 8, spaceBetween: 20 }, // Large devices
            1280: { slidesPerView: 10, spaceBetween: 20 }, // Extra-large devices
          }}
        autoplay={{
            delay: 800, // Delay between slides (ms)
            disableOnInteraction: false, // Keeps autoplay running even after user interaction
          }}
          loop={true} // Enables infinite looping
        className=""
      >
        {images.map((image, index) => (
          <SwiperSlide key={index}>
            <img
              src={image}
              alt={`Slide ${index + 1}`}
              className="w-[64px] h-[64px]"
            />
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
};

export default Slider;
